export const i18nMappings = [{
  CardHolder_Toolbar_Close: _TL_('Hide tile'),
  CardHolder_Toolbar_Add: _TL_('Add or remove overview tiles'),
  CardHolder_Toolbar_Refresh: _TL_('Refresh'),
  CardHolder_Toolbar_Hide: _TL_('Hide tile'),
  CardHolder_Toolbar_Help: _TL_('Help'),
  CardHolder_Toolbar_Enlarge: _TL_('Enlarge'),
  CardHolder_Toolbar_Shrink: _TL_('Shrink'),
  CardHolder_Toolbar_SmallSize: _TL_('Tile size: small'),
  CardHolder_Toolbar_MediumSize: _TL_('Tile size: medium'),
  CardHolder_Toolbar_LargeSize: _TL_('Tile size: large'),
  CardHolder_Toolbar_Toggle: _TL_('Toggle'),
  Loading: _TL_('Loading...'),
  'More options for {{item}}': _TL_('More options for {{item}}'),
}];
